import Splide from "@splidejs/splide";

document.addEventListener('DOMContentLoaded', () => {

    const projectsOverview = document.querySelector('.post-type-archive-projecten')
    if (projectsOverview !== null) {

        const mainHeroSlide = new Splide('.js-projects-overview-slider', {
            type: "loop",
            pagination: false,
            drag: false,
            gap: 0,
            snap: true,
            perMove: 1,
            autoplay: true,
            interval: 5000,
            speed: 2000,
            pauseOnHover: true,
            easing: "ease-in-out",
            breakpoints: {
                1023: {
                    gap: '5rem',
                    height: "auto",
                },
            },
        })

        mainHeroSlide.mount()

    }
})